import { parseJsonField } from "../../utils/parseJsonField";
import "../../css/pageLayout.css"

function ImageTextSection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const imagePosition = settings.image_position || "left";

  const imageSrc = settings.image_url
    ? `${"https://iacdc.tau.ac.il"}${settings.image_url}`
    : null;

  return (
    <section className={`image-text-section image-${imagePosition}`}>
      <div className="image-text-wrapper">
        <div className="image-text-image">
          {imageSrc ? (
            <img style={{marginTop: "85%"}} src={imageSrc} alt={settings.title || ""} />
          ) : (
            settings.image_id && <div>Image ID: {settings.image_id}</div>
          )}
        </div>
      </div>
    </section>
  );
}

export default ImageTextSection;